;(function () {
  
  var searchIsOpen = false;
  var navIsOpen = false;
  var SearchTrigger = document.querySelector('.js-toggle-flyout-search');
  var NavTrigger = document.querySelector('.js-toggle-navigation');
  SearchTrigger && SearchTrigger.addEventListener('click', function (event) {
    searchIsOpen = !searchIsOpen;

    if (searchIsOpen) {
      SearchTrigger.setAttribute('aria-pressed', true);
      Drupal.toggleFlyoutSearch(searchIsOpen);
    } else {
      SearchTrigger.setAttribute('aria-pressed', false);
      Drupal.toggleFlyoutSearch(searchIsOpen);
    }

    event.preventDefault();
  });
  NavTrigger && NavTrigger.addEventListener('click', function (event) {
    event.preventDefault();
    document.body.classList.toggle('nav-is-active');
    navIsOpen = !navIsOpen;
  });
  document.addEventListener('keydown', function (_ref) {
    var keyCode = _ref.keyCode;
    searchIsOpen = keyCode === 27 ? false : searchIsOpen;
  });

  
    window.Ateed.Components.Header = function($container) {

        var self = this;
        this.$elements = {
            siteContainer: $('body > .dialog-off-canvas-main-canvas > .site-container'),
            container: $container,
            megaMenu: $('.ateed-mega-menu')
        };

        var isMicro = '.ateed-header';

        if ($container.hasClass('ateed-header-micro')) {
            // Force menu level to root
            $('.expanded.dropdown').removeClass('active');
            $('.ateed-dormant-navigation > li:nth-child(1)').addClass('active');

            isMicro = '.ateed-header-micro';
        }

        // force orphaned pages to show the navigation menu that is most relevant
        if (($('body.path-taxonomy')[0] || $('body.path-search')[0]) &&
            $('.ateed-dormant-navigation > li.active').length === 0) {
            if ($('body.path-taxonomy')[0]) {
                // use the visit menu for taxonomy pages
                $('.ateed-dormant-navigation > li:nth-child(5)').addClass('active');
            } else {
                // use the about menu for search or other pages
                $('.ateed-dormant-navigation > li:nth-child(6)').addClass('active');
            }
        }

        this.$elements.siteContainer.prepend('<div class="ateed-mm-backdrop"></div>');
        this.$elements.backdrop = $('.ateed-mm-backdrop');

        var menuHelper = new Ateed.Components.Header.MenuHelper();
        var levelTwoSurplusHandler = new Ateed.Components.Header.LevelTwoSurplusCounter();
        if ($container.length > 0) {

            self.viewModel = new Vue({
                el: isMicro,
                data: {
                    displaySearch: false,
                    searchValue: '',
                    levelOne: Object.assign({}, menuHelper.levels[0]), //Clone, as mega menu L1&L2 can change, this can't
                    levelTwo: Object.assign({}, menuHelper.levels[1]), //Clone, as mega menu L1&L2 can change, this can't
                    megaLevels: menuHelper.levels,
                    enabled: menuHelper.enabled,
                    displaySectionMenu: false,
                    displayMegaMenu: false,
                    displayLevelTwoSurplusToggle: false,
                    displayLevelTwoSurplusLinks: false
                },
                ready: function() {
                    this.initDocumentClickHandlers();
                    var vm = this;
                    //Do initial surplus element migrations
                    setTimeout(function() {
                        levelTwoSurplusHandler.onLevelTwoChange(vm.onLevelTwoSurplusCalculated);
                    },0);
                    //Needed if user's browser start very small then gets resized bigger
                    $(window).resize(function() {
                        levelTwoSurplusHandler.onLevelTwoChange(vm.onLevelTwoSurplusCalculated);

                        if (vm.displayMegaMenu) {
                          self.$elements.backdrop
                          .height($(window).width() < 960 ? $('.ateed-mega-menu').height()-75 : $('.ateed-mega-menu').height())
                        }
                    });
                },
                computed: {
                    sectionMenuArrowCss: function () {
                        return this.displaySectionMenu ? 'ateed-arrow-up-hollow-xs-interactive' : 'ateed-arrow-down-hollow-xs-interactive'
                    }
                },
                methods: {
                    initDocumentClickHandlers: function(){
                        $(document).on('click', function(e) {
                            var $target = $(e.target);
                            if(!matchesSelector($target, '.ateed-nav-level-1 a|.ateed-nav-level-1 a strong,b')) {
                                this.displaySectionMenu = false;
                            }
                            if(!matchesSelector($target, '.ateed-toggle-surplus|.ateed-toggle-surplus .ateed-indicator')) {
                                this.displayLevelTwoSurplusLinks = false;
                            }
                            if(!matchesSelector($target, '.ateed-nav-level-2-surplus li *|.ateed-nav-level-2 > ul > li a|.ateed-nav-level-2 > ul > li a *|.ateed-mega-menu a *|.ateed-mega-menu a|.ateed-header-menu-toggle')) {
                                this.hideMegaMenu();
                            }
                        }.bind(this));
                    },
                    startSearch: function () {
                        this.displaySearch = true;
                    },
                    addAnimation: function () {
                        document.getElementById('keys').className += ' header-search-loading-anim'
                    },
                    clearSearch: function () {
                        this.searchValue = '';
                        $('#keys').val('');
                    },
                    stopSearch: function () {
                        this.searchValue = '';
                        this.displaySearch = false;
                    },
                    /************************* Navigation *************************/
                    onLevelTwoSurplusCalculated: function(surplusCount) {
                        if (this.levelTwo.children !== undefined) {
                            //Hide trailing n elements
                            var max = this.levelTwo.children.length-1;
                            // reset elements each time the size changes
                            this.levelTwo.children.forEach(function (child) {
                                child.isVisible = true;
                            });
                            for(var i=max; i>(max-surplusCount); i--) {
                                var child = this.levelTwo.children[i];
                                child.isVisible = false;
                            }
                            this.displayLevelTwoSurplusToggle = surplusCount > 0;
                        }
                    },
                    _hideLevels: function(level) {
                        for(var i=0; i<this.megaLevels.length; i++) {
                            this.megaLevels[i].isVisible = false;
                        }
                    },
                    onSectionClick: function(node, event) {
                        if (this.displayMegaMenu) {
                            this.displayMegaMenu = false;
                        }
                        if (node.isActive) {
                            if ( ! this.displaySectionMenu) {
                                event.preventDefault();
                                event.stopPropagation();
                            }

                            this.displaySectionMenu = !this.displaySectionMenu;
                        }
                    },
                    onLevelTwoClick: function(child, event) {
                        if(child.children[0]) {

                            if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) {
                                this.hideMegaMenu();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            else {
                                this._hideLevels();
                                this.megaLevels.$set(child.depth, new Ateed.MenuLevel(child.parent, child, child.depth+1, true));
                                this.showMegaMenu();
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        }
                    },
                    showSecondaryNavSurplusLinks: function() {
                        this.displayLevelTwoSurplusLinks = true;
                    },
                    //Display level of user's current page.
                    displayCurrentLevel: function() {
                        var current = menuHelper.current;
                        if (current) {
                          this._hideLevels();
                          this.megaLevels.$set(current.depth-1, new Ateed.MenuLevel(current.parent.parent, current.parent, current.depth, true));
                          this.showMegaMenu();
                        }
                    },
                    showMegaMenu: function() {
                        var vm = this;
                        setTimeout(function() {
                            self.$elements.backdrop
                            .height($(window).width() < 960 ? $('.ateed-mega-menu').height()-75 : $('.ateed-mega-menu').height())
                            .show();
                            vm.displayMegaMenu = true;
                        },0);
                    },
                    hideMegaMenu: function() {
                        this.displayMegaMenu = false;
                        self.$elements.backdrop.hide();
                    },
                    ascend: function(level, event) {
                        event.preventDefault();
                        event.stopPropagation();
                        this._hideLevels();
                        if(level.number !== 2) { //If we aren't ascending to root level, use level parents
                        this.megaLevels.$set(level.number-2, new Ateed.MenuLevel(level.parent.parent, level.parent, level.number-1, true));
                    } else { //Otherwise must use root of tree.
                        this.megaLevels.$set(level.number-2, new Ateed.MenuLevel(null, menuHelper.tree, level.number-1, true));
                    }
                    this.showMegaMenu();
                },
                descend: function(level, child, event) {
                    if(child.children[0] && level.number < 3) {
                        this._hideLevels();
                        this.megaLevels.$set(level.number, new Ateed.MenuLevel(child.parent, child, level.number+1, true));
                        this.showMegaMenu();
                        event.preventDefault();
                        event.stopPropagation();
                    }
                },
                megaMenuArrowCss: function (child) {
                    if (child.isActive) {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) return 'ateed-arrow-up-hollow-xs-interactive';
                        else return 'ateed-arrow-down-hollow-xs-interactive';
                    } else {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) return 'ateed-arrow-up-hollow-xs';
                        else return 'ateed-arrow-down-hollow-xs';
                    }
                },
                megaMenuOpenCss: function (child) {
                    if (child.isActive) {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) {
                            return 'ateed-menu-open';
                        }
                        else {
                            return 'ateed-menu-closed';
                        }
                    }
                    else {
                        if (this.displayMegaMenu && this.megaLevels[child.depth].uri === child.uri) {
                            return 'ateed-menu-open';
                        }
                        else {
                            return 'ateed-menu-closed';
                        }
                    }
                }
            }
        });

        // remove level one indicator if the page is orphaned in the nav structure
        if (menuHelper.levels[0] && menuHelper.levels[0].uri === '') {
            $('small.ateed-level-one-indicator').remove();
        }

        // only show the header after the vue binding has mounted
        $container.show();
    }
};
function matchesSelector($el, selectorsStr) {
    var selectors = selectorsStr.split('|');
    var result = false;
    selectors.forEach(function(selector) {
        if($el.is(selector)) {
            result = true;
        }
    });
    return result;
}
})();

(function () {
  
      var isExpandedMenuItems = document.querySelectorAll('.ateed-header .navigation--secondary .is-expanded');
      isExpandedMenuItems.forEach(function (menuItem) {
        var expandButton = document.createElement('button');
        expandButton.appendChild(document.createTextNode('Toggle'));
        expandButton.setAttribute('type', 'button');
        expandButton.classList.add('menu__toggle');
        expandButton.addEventListener('click', function (_ref) {
          var target = _ref.target;
          return target.parentElement.classList.toggle('is-open');
        });

        if (menuItem.classList.contains('active-trail')) {
          menuItem.classList.add('is-open');
        }

        menuItem.insertBefore(expandButton, menuItem.lastElementChild);
      });
  
})(Drupal);

